import React, { memo } from "react";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";

interface CustomSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
  id,
}) => {
  const { i18n } = useTranslation();

  return (
    <div className="flex gap-4">
      <div>
        <button
          id={id}
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange(!checked)}
          tabIndex={0}
          onKeyDown={(e) => {
            if (!disabled && (e.key === " " || e.key === "Enter")) {
              e.preventDefault();
              onChange(!checked);
            }
          }}
          className={`relative h-5 w-9 items-center flex rounded-full transition-colors focus:outline-none
          ${checked ? "bg-purple-primary" : "bg-gray-300"}
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        `}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition-transform
            ${checked ? i18n.language === 'en' ? "translate-x-5" : "-translate-x-5" : "translate-x-0"}
          `}
          />
        </button>
      </div>
      {label && (
        <label
          htmlFor={id}
          className={cn(
            "text-sm font-normal leading-tight",
            disabled && "text-gray-800 cursor-not-allowed"
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default memo(CustomSwitch);
